import { Dispatch, SetStateAction, useState } from 'react';
import { FieldValues, useFormContext } from 'react-hook-form';

import BankList from '#providers/BankList';
import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { BoxIcon, Button, Text } from '#atoms';

import { BankSelectModal } from 'src/components/organisims/BankSelectModal';
import { useSubmitBankNumber } from './hooks';

import {
  BankInfoContainer,
  ButtonContainer,
  Container,
  ItemBox
} from './styles';
import { useToast } from '#providers/ToastProvider';

export function BillingRegAccountPage({
  setStep
}: {
  setStep: Dispatch<SetStateAction<string>>;
}) {
  const methods = useFormContext<{
    bankName: string;
    bankId: string;
    name: string;
    number: string;
    residentNumberFirst: string;
    residentNumberLast: string;
  }>();

  const { showToast } = useToast();
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const submitBankNumber = useSubmitBankNumber();

  const handleSubmitClick = async (data: {
    bankName: string;
    bankId: string;
    name: string;
    number: string;
    residentNumberFirst: string;
    residentNumberLast: string;
  }) => {
    const { residentNumberFirst, residentNumberLast, ...rest } = data;

    const submitData = {
      residentNumber: residentNumberFirst.concat(residentNumberLast),
      ...rest
    };

    if (Object.values(submitData).every(value => value)) {
      submitBankNumber({
        ...submitData
      });
    } else {
      showToast({
        type: 'fail',
        message: '입력값을 확인해주세요.'
      });
    }
  };

  return (
    <PrevHeaderBarWithTitleTemplate
      onPrev={() => setStep('resident')}
      title="수입관리"
    >
      <Container>
        <div>
          <Text textStyle="t1">정산 받을</Text>
          <Text textStyle="t1">계좌를 등록해주세요</Text>
        </div>
        <BankInfoContainer>
          <li>
            <ItemBox className="bank" onClick={() => setModalOpen(true)}>
              <Text textStyle="bb">
                {methods.watch('bankName')
                  ? `${methods.watch('bankName')}`
                  : '은행'}
              </Text>
              <BoxIcon type="next-arrow" size={15} onlyIcon={true} />
            </ItemBox>
          </li>
          <li>
            <ItemBox>
              <Text textStyle="bb">예금주</Text>
              <input
                className="w-full px-16 py-15 rounded-8 bg-[#24222A] text-center"
                {...methods.register('name')}
                placeholder="-"
              />
            </ItemBox>
          </li>
          <li>
            <ItemBox>
              <Text textStyle="bb">계좌번호</Text>
              <input
                className="w-full px-16 py-15 rounded-8 bg-[#24222A] text-center"
                {...methods.register('number')}
                placeholder="-"
              />
            </ItemBox>
          </li>
        </BankInfoContainer>
        {modalOpen && (
          <BankList>
            <BankSelectModal
              onComplete={item => {
                methods.setValue('bankName', item.bankName);
                methods.setValue('bankId', item.bankId);
                setModalOpen(false);
              }}
              onClose={() => setModalOpen(false)}
            />
          </BankList>
        )}
      </Container>
      <ButtonContainer>
        <Button onClick={methods.handleSubmit(handleSubmitClick)}>완료</Button>
      </ButtonContainer>
    </PrevHeaderBarWithTitleTemplate>
  );
}
